<template>
  <div class="white_container start_container">
    <h4>cart page</h4>
  </div>
</template>

<style lang="scss">

</style>

<script>
  export default {
    name: 'Cart',
    components: {

    }
  }
</script>
